import { HelmetProvider, Helmet } from "react-helmet-async";
import TopHeader from "../components/TopHeader";
import ControleBloc from "../blocs/controleBloc";
import "../assets/_landingPage.scss";
import BannerGrey from "../components/bannerGrey";
import Avantages from "../components/avantages";
import Formules from "../components/formules";
import Footer from "../components/Footer";
import CalendarBloc from "../components/landingPage/calendarBloc";
import TestimonialBloc from "../blocs/TestimonialBloc";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchBlocsActifs } from "../store/slices/blocsReducer";
import { useDispatch } from "react-redux";
import BlocLeftImg from "../components/landingPage/blocLeftImg";
import Faqs from "../blocs/Faqs";
import DarkBloc from "../components/landingPage/darkBloc";
import { fetchReviewsPro } from "../store/slices/avisSlice";
import { useNavigate } from "react-router-dom";
const LandingPage = () => {
  const dispatch=useDispatch()
  const navigate=useNavigate()
  const {  testimonials,faqs, status } = useSelector((state) => state.blocs);
 // Correct way to access reviewsPro
 const {reviewsPro,statusLandingPage} = useSelector(state => state.avisClient);
//  console.log({reviewsPro})
useEffect(() => {
  dispatch(fetchReviewsPro())
        if (status === 'idle') {
            dispatch(fetchBlocsActifs());
          
            
        }
    }, [dispatch, status]);
    const blocks = [
      { icon: '/images/eye-open.svg', title: 'Augmentez votre visibilité', text: 'Touchez un public plus large et boostez vos revenus avec des rendez-vous en ligne illimités.' },
      { icon: '/images/lightning-filled.svg', title: 'Choisissez votre mode de réservation', text: 'Gardez la main sur vos disponibilités, acceptez les réservations instantanées ou préférez la prise de rendez-vous planifiée.' },
      { icon: '/images/bank-note-01.svg', title: 'Pas de TPE ni de frais cachés', text: 'Twyny gère les paiements de vos clients pour vous, avec une rémunération rapide et sans frais supplémentaires : 0% de commission Pro, 0% sur les paiements en ligne !' },
      { icon: '/images/users-profiles-plus.svg', title: 'Ne ratez plus jamais un client !', text: 'Twyny envoie automatiquement des rappels par e-mail et SMS à vos clients pour réduire les risques d’oubli de rendez-vous.' },
    ];
    const blocksServices = [
      { icon: '/images/smiley-happy.svg', title: 'Une plateforme conçue pour vous', 
        text: 'Twyny simplifie la vie des professionnels en s’adaptant à vos besoins, pour favoriser la croissance de votre activité.' },
      { icon: '/images/stars.svg', title: '100 % transparent',
         text: 'Bénéficiez de nos services en toute confiance : de l’inscription aux paiements, tout est clair et sans surprise.' },
      { icon: '/images/users.svg', title: 'Un support disponible 7j/7',
         text: 'Notre équipe est à votre écoute tous les jours pour vous accompagner et répondre à vos questions.' },
    ];
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Page landing Page </title>
          <meta name="description" content=" Landing page" />
        </Helmet>
      </HelmetProvider>
      <TopHeader btn={true} />
      <div className="">
        <ControleBloc />
      </div>
      <BannerGrey />
      <div className="container px-80">
        <Avantages blocks={blocks}
        title={'Artisans et prestataires de services, Twyny est enfin là pour gérer vos rendez-vous !'}
   
        text={"Profitez d’un système fluide avec un agenda connecté qui automatise la prise de rendez-vous et élimine les appels chronophages."}
        />
      </div>
      {/*bloc les formules */}
      <div className="box-grey space-bloc" id="formules-section">
        <div className="container">
          <div className="w-75">
            <h2 className="grey500 ">
              Quelle que soit la formule, vous êtes toujours gagnant !
            </h2>
            <p className="grey66 mt-16">
              Avec des frais moyens de seulement 20 centimes par rendez-vous,
              vous bénéficiez d’un système clé en main pour gérer votre
              activité.
            </p>
          </div>
          <Formules/>
        
        </div>
      </div>
      <div className="container">
        <CalendarBloc></CalendarBloc>
       
      </div>
      <BlocLeftImg/>
      <div className="container">
      <TestimonialBloc testimonials={reviewsPro} status={statusLandingPage} title={"Ce que disent nos pros"} type="pro" />
      <div className=" space-bloc">
        <Avantages blocks={blocksServices}
        title={'La simplicité au service de votre métier'}
        col={4}
      
        button={
          <button 
            className="twyny-cta-primary"
            onClick={()=>navigate('/registerPrestataire')}
          >
           Découvrir gratuitement
          </button>
        }
        />
      </div>
      <Faqs faqs={faqs} status={status} />
    
      </div> 
      <div className="container-fluid">
         <DarkBloc/>
      </div>
      
      <Footer/>
    </>
  );
};
export default LandingPage;
